import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

interface MetaTag {
  [key: string]: string
}

interface RouteMeta {
  title?: string
  metaTags?: MetaTag[]
}

export default (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): void => {
  document.title = typeof to.meta.title === 'string' ? to.meta.title : 'Moja Akademia Przyszłości'

  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags) as { meta: RouteMeta } | undefined
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map((el) =>
    el.parentNode?.removeChild(el)
  )

  if (!nearestWithMeta) {
    return next()
  }

  nearestWithMeta.meta
    .metaTags!.map((tagDef: MetaTag) => {
      const tag = document.createElement('meta')

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key])
      })

      tag.setAttribute('data-vue-router-controlled', '')
      return tag
    })
    .forEach((tag) => document.head.appendChild(tag))

  return next()
}
